import { useState } from "react";
import { Dialog, DialogPortal, DialogOverlay } from "@/components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";
import AgentCreationWizard from "./AgentCreationWizard";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AgentCreationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// Create a custom modal with margins and semi-transparent backdrop
const AgentCreationModal = ({ isOpen, onClose }: AgentCreationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()} modal={true}>
      <DialogPortal>
        <DialogOverlay className="bg-black/40" />
        <DialogPrimitive.Content
          className={cn(
            "fixed left-[50%] top-[50%] z-50 w-[calc(100vw-48px)] h-[calc(100vh-64px)] sm:w-[calc(100vw-80px)] md:w-[90vw] max-w-7xl translate-x-[-50%] translate-y-[-50%] rounded-xl border border-gray-200 bg-white p-0 shadow-xl overflow-hidden duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]"
          )}
        >
          <Button 
            variant="ghost" 
            size="icon" 
            className="absolute right-4 top-4 z-10"
            onClick={onClose}
          >
            <X className="h-6 w-6" />
          </Button>
          <div className="mx-auto py-6 px-4 md:px-8 w-full h-full overflow-y-auto">
            <AgentCreationWizard onClose={onClose} />
          </div>
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
};

export default AgentCreationModal; 